// This may look silly, why on earth access a property this way?
// Well, it has to do with that we replace environment properties (located in .env)
// at azure pipelines release stage, after the build has been compiled and optimized into vanilla js,
// in order to configure different environments without have to produce a build for each environment.

// When create-react-app creates a build, the environment values located in .env (or .env.Development)
// are inserted into the code were we access process.env.{propertyName}.

// When creating a production build, we don't know the properties, (Staging/Production settings differ).
// Thats why the property values in .env are keyed like ${{KEY_NAME}} so they can be replaced later
// when we perform the actual release.

// When a production build is produced, it is optimized. If the typescript compiler
// notices we do a check for example, process.env.PRICE_PRG_ENVIRONMENT === 'Production'
// it will be turned into #{{PRICE_PRG_ENVIRONMENT}} === 'Production', which the typescript
// compiler of course can see will never be true, hence it will remove that code.

// If we than late replace ${{PRICE_PRG_ENVIRONMENT}} with e.g. 'Production', the result
// will be that our initial if branch will not be executed since it was optimized away.

// However, if instead of going directly via the property and do it like this,
// the typescript compiler is not smart enough to optimize the code away.

// We should be careful with adding environment properties that we perform
// checks against, because of this problem. If we need to perform if checks on
// properties we will have to do it this way. Very hacky, but it works.
const envPropStr = getEnvStr('ENVIRONMENT');
const custNamePropStr = getEnvStr('CUSTOMER', 'NAME');
export const appEnvironment = process.env[envPropStr];
export const custName = process.env[custNamePropStr];

function getEnvStr(...parts: string[]) {
    return ['REACT', 'APP', ...parts].join('_');
}
